import {
  appConfig,
  getAuthToken,
  getCompanyId,
  refreshAccessToken,
} from '$utils'
import { StockClient } from '@loadedhub/loaded-stock-api-sdk'

const authRefreshTokenAwareHttpClient = {
  async fetch(input, init) {
    let response = await fetch(input, init)

    if (response.status === 403) {
      // Try to redeem refresh token
      await refreshAccessToken()
      const newToken = getAuthToken()

      // Update the Authorization header
      if (init && init.headers) {
        if (init.headers instanceof Headers) {
          init.headers.set('Authorization', `Bearer ${newToken}`)
        } else if (typeof init.headers === 'object') {
          init.headers['Authorization'] = `Bearer ${newToken}`
        }
      }
      response = await fetch(input, init)
    }
    return response
  },
}

const newStockClient = (companyId: string | (() => string)) =>
  new StockClient(
    {
      authToken: () => getAuthToken(),
      companyId: companyId,
    },
    appConfig.get<string>('stockApiUrl'),
    authRefreshTokenAwareHttpClient
  )

// Note that as this client is a singleton, instantiated once when then app is
// loaded, we need to make sure that properties that can change are functions
// that return the current value.
const stockClient = newStockClient(() => getCompanyId())

export default stockClient

// Expose the stock client instance as a global variable, this then can be
// accessed from old AngularJS code directly without us having to create and
// manage another client there.
window.__Loaded['stockClient'] = stockClient
window.__Loaded['newStockClient'] = newStockClient
